import React, { useState, useMemo} from "react";
import Footer from "../components/Footer";
import Navigationbar from "../components/Navigationbar";
import Accordion from "../components/StrategiComponents/Accordion";
import CircleDiagram from "../components/StrategiComponents/CircleDiagram";
import ScrumBoard from "../components/StrategiComponents/ScrumBoard";
import AdminDropdown from "../components/AdminDropDown";
import FileUpload from "../components/StrategiComponents/FileUpload";
import ExpectedRevenueCard from "../components/StrategiComponents/ExpectedRevenueCard";
import '../Styles/Strategi.css'
import YearlyTaskComponent from "../components/StrategiComponents/YearlyTaskComponent";
import '../Styles/button.css'
import SWOTComponent from "../components/StrategiComponents/SWOTComponent";
import { useSelectedCompany } from "../contexts/SelectedCompanyContext";
import { useAuth } from "../contexts/AuthContext";
import { useAdmin } from "../contexts/AdminContext";
import useFetchCompanies from "../hooks/CompanyHooks/useFetchCompanies";
import useFetchYears from "../hooks/useFetchYears";
import useFetchAccordions from "../hooks/AccordionHooks/useFetchAccordions";
import useAddAccordion from "../hooks/AccordionHooks/useAddAccordion";
import useDeleteAccordion from "../hooks/AccordionHooks/useDeleteAccordion";
import useFetchCompanyId from "../hooks/CompanyHooks/useFetchCompanyId";
import useUpdateAccordion from "../hooks/AccordionHooks/useUpdateAccordion";
import useUpdateTaskStatus from "../hooks/useUpdateTaskStatus";
import useUpdateAccordionStatus from "../hooks/AccordionHooks/useUpdateAccordionStatus";
import LoadingComponent from "../components/LoadingComponent";
import SelectYear from "../components/SelectYear";



function Strategi() {
    const auth = useAuth();
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const { companies, isLoading: isCompaniesLoading, error } = useFetchCompanies();
    const { years, isLoading: isYearLoading, error: yearError } = useFetchYears();
    const {selectedCompany, setSelectedCompany} = useSelectedCompany();
    const [expectedRevenue, setExpectedRevenue] = useState([]);
    const {isAdmin, setIsAdmin} = useAdmin();
    const filteredExpectedRevenueForSelectedCompany = expectedRevenue.filter(item => item.company === selectedCompany);
    const { companyId, isLoading: isCompanyLoading, error: companyError } = useFetchCompanyId(selectedCompany);
    const { quarters, setQuarters, isLoading, error: quartersError } = useFetchAccordions(companyId, selectedYear);
    const addAccordion = useAddAccordion(companyId, selectedYear, setQuarters);
    const deleteAccordion = useDeleteAccordion(companyId, selectedYear, setQuarters);
    const updateAccordion = useUpdateAccordion(companyId, selectedYear, setQuarters);
    const updateTaskStatus = useUpdateTaskStatus(companyId, selectedYear, setQuarters);
    const updateAccordionStatus = useUpdateAccordionStatus(companyId, selectedYear, setQuarters);
   
  if (isCompanyLoading || isCompanyLoading || !selectedCompany || isLoading || isCompaniesLoading || isYearLoading) {
    return <LoadingComponent />;
  }
    return (
        <>
<Navigationbar />
<div className="container strategi-container">
    <h1 className="main-header">Strategi</h1>
        {isAdmin && (
            <div>
                <AdminDropdown
                    selectedCompany={selectedCompany}
                    setSelectedCompany={setSelectedCompany}
                    allCompanies={companies}
                />
            </div>
        )}
        {auth.currentUser ? (
            <div>
            <SelectYear selectedYear={selectedYear} setSelectedYear={setSelectedYear} handleChangeYear={setSelectedYear}></SelectYear>
        <h3 className="sub-header">Tasks og Scrumboard</h3>
<div className="tasks-and-scrumboard-container">
    <div className="accordions-container">
        {['Q1', 'Q2', 'Q3', 'Q4'].map(quarterKey => (
            <div key={quarterKey} className="quarter-container">
                <h4 className="">{quarterKey}</h4>
                {quarters[quarterKey] && quarters[quarterKey].map((accordion) => (
                    <div key={accordion.timeStamp} >
                                <Accordion
                                    title={accordion.title}
                                    content={accordion.content}
                                    isFinished={accordion.isFinished}
                                    isAdmin={isAdmin}
                                    onContentChange={(content) => updateAccordion(quarterKey, accordion.timeStamp, { content })}
                                    onTitleChange={(title) => updateAccordion(quarterKey, accordion.timeStamp, { title })}
                                    onFinishedChange={(isChecked) => updateAccordionStatus(quarterKey, accordion.timeStamp, isChecked)}
                                />
                                {isAdmin && 
                                    <button className="delete-btn" onClick={() => deleteAccordion(quarterKey, accordion.timeStamp)}>Slet</button>
                                }
                            </div>
                        ))}
                        {isAdmin && 
                            <button className="add-btn" onClick={() => addAccordion(quarterKey)}>Tilføj</button>
                        }
                    </div>
                    
                ))}
                </div>
                 <div className="scrumboard-container">
            <ScrumBoard isAdmin={isAdmin} onTaskStatusChange={updateTaskStatus} selectedCompany={selectedCompany} selectedYear={selectedYear} companyId={companyId}/>
        </div>
                </div>
                <div className="">
                    <div>
                <h3 className='sub-header'>Årlige opgaver {selectedCompany}</h3>
                </div>
                <YearlyTaskComponent selectedYear={selectedYear} selectedCompany={selectedCompany} isAdmin={isAdmin} />
                </div>
                <div className="row">
                    <div>
                        <SWOTComponent isAdmin={isAdmin} selectedCompany={selectedCompany}></SWOTComponent>
                    </div>
                </div>
                <div className="row">
                    <div>
                            <h3 className="sub-header">Filer</h3>
                            <FileUpload isAdmin={isAdmin} selectedCompany={selectedCompany} selectedYear={selectedYear} auth={auth}/> 
                    </div>
                    {
    filteredExpectedRevenueForSelectedCompany.map((revenueData, index) => (
        <ExpectedRevenueCard key={index} data={revenueData} isAdmin={isAdmin} />
    ))
}
                </div>
                </div>
                ) : (
                    <div>
                        <div className="row mt-5">
                            <div className="col d-flex justify-content-center">
                                <h2 className="login-message">Login for at se din Strategi</h2>
                            </div>
                        </div>
                    </div>
                )}
                </div>
            <Footer/>
        </>
    );
}
export function getNewTitles(existingTasks, accordionTitles) {
    const allTasks = [...existingTasks["To-Do"], ...existingTasks["Doing"], ...existingTasks["Done"]];
    const newTitles = accordionTitles.filter(title => !allTasks.includes(title));
    return newTitles;
}
export default Strategi;